import { OnInit, ViewChild, Component } from "@angular/core";
import { MatTableDataSource, MatDialog } from "@angular/material";
import { SearchFilterComponent } from "../../../search-filter/search-filter.component";
import { Router } from "@angular/router";
import { AuthService } from "../../../../services/auth.service";
import { MenuService } from "../../../../services/menu.service";
import { CashDeskService } from "../../../../services/cash-desk.service";
import { SearchFilter, IFilterResponse } from "../../../../infrastructure/iFilter-component";
import { PatientCashDeskSeachItem } from "../../../../model/patient/patient-pending-cash-desk-search-item";
import { NotificationToastService } from "../../../../services/notification-toast.service";
import { PagerControlComponent } from "../../../controls/pager/pager-control.component";

@Component({
  selector: 'pending-cash-desk-search',
  templateUrl: './pending-cash-desk-search.component.html',
  styleUrls: ['./pending-cash-desk-search.component.css']
})
export class PendingCashDeskSearchComponent implements OnInit {

  loading: boolean; 
  searchFilters: SearchFilter[];
  patientPendingCashDeskSeachItem: PatientCashDeskSeachItem[] = [];
  displayedColumns: string[] = ['Protocol', 'PatientFullName', 'Practice', 'MedicalOrderAmount', 'CashDeskStateDescription', 'Star'];
  dataSource = new MatTableDataSource([]);
  @ViewChild("searchFilter", {static: false}) searchFilter: SearchFilterComponent;
  @ViewChild("pager", {static: true}) pager: PagerControlComponent;

  constructor(public dialog: MatDialog
    , private router: Router
    , private cashDeskService: CashDeskService
    , private menuService: MenuService
    , private authService: AuthService
    , private notificationToastService: NotificationToastService) {
    this.menuService.setMenuTitle("Cobranza", "Paciente");
  }

  ngOnInit(): void {

  }

  selectedPageIndexChange(pagedItems: any[]) {
    this.dataSource = new MatTableDataSource(pagedItems);
    this.loading = false;
  }



  onEndSearch(response: IFilterResponse<PatientCashDeskSeachItem>) {
    this.patientPendingCashDeskSeachItem = response.items;
    this.searchFilters = response.searchFilters;
    this.pager.setItems(this.patientPendingCashDeskSeachItem);
  }

  onStartSearch() {
    this.loading = true;
  }

  invoicePatientCashDeskRedirect(item: PatientCashDeskSeachItem): void {
    this.router.navigate(['invoice-patient-cash-desk-edit', item.MedicalAppointmentId]);
  }

  cashDeskManualAssociationRedirect(item: PatientCashDeskSeachItem): void {
    this.router.navigate(['cash-desk-manual-association', item.MedicalAppointmentId]);
  }
}
